import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SubTitle from '../Components/SubTitle';
import ImageBox from '../Components/ImageBox';
import SpliderImage from '../Components/SpliderImage';
import { currencyFormat } from '../Functions';
import InputSpinner from '../Components/InputSpinner';
import { add_item } from '../redux/slices/CartSlice';
import { setErrorMessage, setSuccessMessage } from '../redux/slices/MessageSlice';
import { modalChange } from '../redux/slices/AuthSlice';
import axios from 'axios';
import ProductShow from '../Components/ProductShow';
import { URL } from '../config';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from './Loading';

const ProductSelect = () => {
  const { id } = useParams();
    const dispatch = useDispatch();
    const [product,setProduct]=useState(null);
    const navigate=useNavigate();
    const {currentUser,token}=useSelector((state)=>state.AuthReducer);
    const [titles,setTitle]=useState([{name:'',link:''}]);
    const [quantity,setQuantity]=useState(1);
    const [sizeSelect,setSizeSelect]=useState();
    const {items,items_count,cart_total}=useSelector((state)=>state.CartReducer);
    const titlesOpinion=[{name:'منتجات قد تعجبك',link:''}]
    const [products,setProducts]=useState([]);
  
    const [load,setLoad]=useState(false);
    
    const add_item_cart=(productCart)=>{
      if(productCart.quantity<=0){
        dispatch(setErrorMessage('غير متوفر الأن'));
            return;
        }
        let c;
        if(sizeSelect){
           c=sizeSelect.quantity;
        }else{
           c=productCart.quantity;
        }
        items.map((item)=>{
          if(item.product.id===productCart.id){
            if(item.size){
              if(sizeSelect.size===item.size.size)
                  c=c-item.quantity-(quantity-1);
            }else{
              c=c-item.quantity-(quantity-1);
            }
            
          }
        })
        if(c<=0){
          dispatch(setErrorMessage('غير متوفر الأن'));
          return;
        }
      dispatch(add_item({product:productCart,quantity:quantity,size:sizeSelect?sizeSelect:''}))
      dispatch(setSuccessMessage('تم اضافة المنتج للسلة'));

    }
    const decrementQuantity=()=>{
      if(quantity>1){
        setQuantity(quantity-1)
      }
    }
    const increaseQuantity=(q)=>{
      
      if(q){
        if(q>quantity){
          setQuantity(quantity+1)
        }
      }else{
        console.log(sizeSelect)
        if(sizeSelect.quantity>quantity){
          setQuantity(quantity+1)
        }
      }
      
    }
    const buyHandle = () => {
     if(!token){
      dispatch(modalChange());
     }
     else{
      axios.get(`${URL}/api/auth/check_auth`,{
        headers:{
            Authorization:`Bearer ${token}`,
            'Accept':'application/json',
           ' Content-Type':'application/json'
        }})
      .then(function (response) {
        if(response.data){
          navigate('/payment',{state:{items:[{product:product,quantity:quantity,size:sizeSelect}],cart_total:product?.price*quantity}})
        }else{
          dispatch(modalChange());
          console.log(response.data)
        }
    
      })
      .catch(function (error) {
        console.log('error');
      });
     }
      
    }
 
    const size_select_handel=(e,p_sizes)=>{
    if(e.target.value){
      console.log('p_sizes',p_sizes)
      setSizeSelect(p_sizes[e.target.value]);
      if(p_sizes[e.target.value].quantity<quantity){
        dispatch(setErrorMessage(` يوجد ${p_sizes[e.target.value].quantity} فقط من المقاس`));
       setQuantity(p_sizes[e.target.value].quantity)
      }
    }
    else{
      setSizeSelect('');
    }  
    }
  useEffect(()=>{
    setSizeSelect(null);
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setLoad(true);
    
    axios.get(`${URL}/api/product/single/${id}`)
    .then(function (response) {
      if(response.data.success){
        console.log(response.data.data);
        setProduct(response.data.data)
      }
      setLoad(false);
        })
    .catch(function (error) {
      console.log('error');
      setLoad(false);
    });
    axios.get(`${URL}/api/product/products_opinion`)
    .then(function (response) {
      if(response.data.success){
        console.log(response.data);
        setProducts(response.data.data);
      }
      setLoad(false);
        })
    .catch(function (error) {
      console.log('error');
      setLoad(false);
    });
  },[id])
  useEffect(()=>{
    if(product){
      if(product.category){
        setTitle([{name:product.main_category.name,link:`/main_category/${product.main_category.id}/${product.main_category.name}`},
        {name:product.category.name,link:`/category/${product.main_category.id}/${product.main_category.name}/${product.category.id}/${product.category.name}`},
       ])}
        else{
        setTitle([{name:product.main_category.name,link:`/main_category/${product.main_category.id}/${product.main_category.name}`},
        ])}
    }
   
  },[product])
  if(load)
    return <Loading/>
  return (

    <div className='container mt-lg-5 pt-5 mb-2'>
        <SubTitle titles={titles}/>     
        <div className='row d-flex justify-content-center justify-content-lg-start mt-4'>
        <div className='col-12 col-md-8 col-lg-4 ' >
         <SpliderImage image={product?.images} images={product?.product_images}/>
         </div>
         <div className='col-12 col-lg-8  product-select-body px-md-5'>
              <h4 className=" text-warp product-select-body-name ">{product?.name}</h4>
              <div className='d-flex align-items-center'>
              {product?.price_before&&<p className='ms-3 product-select-body-price-before'>{currencyFormat(product?.price_before)}</p>}
              {product?.discount&&<p className='ms-3 fs-6'>خصم {product?.discount}<span className='me-1'>%</span></p>}
              <p className='ms-3 product-select-body-price-after'>{currencyFormat(product?.price)} <span>ج.م</span></p>
              </div>
              <div className='product-select-body-quantity'>
              <i class="fa-solid fa-toolbox"></i>
              <p>المتبقى</p>
              <span>{product?.quantity} </span>
              </div>
              <p style={{ marginBottom:'20px' }}>{product?.description}</p>
              <p style={{ fontSize:'16px' }} >تفاصيل المنتج :   </p>
              <div className='row  product-select-body-details-model'>
                <div className='col result_1'><span>|!!!!|</span> رقم الموديل</div>
                <div className='col result'>{product?.code}</div>
              </div>
              {product?.cloth_source&&(
              <div className='row  product-select-body-details-model'>
              <div className='col result_1'><span>          
              <i class="fa-brands fa-sourcetree"></i>
              </span>مصدر القماش</div>
                <div className='col result'>{product?.cloth_source} </div>       
            </div>
              )}
            {product?.cloth_type&&(
            <div className='row  product-select-body-details-model'>
            <div className='col result_1'><span>          
            <i class="fa-solid fa-transgender"></i>              </span>نوع القماش</div>
              <div className='col result'>{product?.cloth_type} </div>       
            </div>
            )}

             {product?.made_of&&(
            <div className='row  product-select-body-details-model'>
            <div className='col result_1'><span>          
            <i class="fa-solid fa-flag"></i>
            </span>بلد الصنع</div>
              <div className='col result'>{product?.made_of} </div>       
            </div>
            )}
              {product?.factory&&(
            <div className='row  product-select-body-details-model'>
            <div className='col result_1'><span>          
            <i class="fa-solid fa-industry"></i>
            </span> المصنع</div>
              <div className='col result'>{product?.factory} </div>       
            </div>
            )}
              {product?.veil_size&&(
            <div className='row  product-select-body-details-model'>
            <div className='col result_1'><span>          
            <i class="fa-solid fa-minimize"></i>
            </span>مقاس الطرحة</div>
              <div className='col result'>{product?.veil_size} </div>       
            </div>
            )}
             
             
              {product?.size?(
                <div className='row cart-size  align-items-center'>
                <div className='col-sm-4 p-0 ' >
                    <p className='m-0' >المقاس</p>                    
                    </div>
                    <div className='col-sm-8 mt-3 mb-2 d-flex justify-content-between '>
                    <select class="form-select-size" 
                    onChange={(e)=>size_select_handel(e,product?.product_sizes)}
                                id="size"
                                name="size"
                            aria-label="Default select example">
                        <option  value=''>أختر</option>
                            {product?.product_sizes.map((size,idx)=>(
                                <option disabled={size?.quantity<=0?true:false} 
                                key={idx} value={idx}>{size.size} 
                                  {size?.quantity<=0&&'- نفذت الكمية'}</option>
                            )
                            )}
                        </select>
                    </div> 
                   
                   
                </div>  
                ):(
                  <div className=' row cart-size'>
                  <div className='mb-3 mt-3 d-flex align-items-center justify-content-between'>
                    
                    <p className='m-0 ' >السعر</p>                    
                   
                       <p className='m-0' style={{fontSize:'26px'}}>{currencyFormat(product?.price*quantity)} <span>ج.م</span></p>
                   </div>
                   {product?.quantity&&(
                    <>
                      <div className='   mt-3 mb-3 d-flex align-items-center justify-content-between '>  
                  <p >الكمية</p>
                      <InputSpinner quantity={quantity}
                      decrementQuantity={decrementQuantity} 
                      increaseQuantity={()=>increaseQuantity(product?.quantity)}/>
                     </div>
                     <div className=' col-md-6 d-flex mt-3'>  
                       <button onClick={()=>add_item_cart(product)} className="product-select-button product-select-cart-button">أضافة للسلة</button>
                     </div>
                     <div className=' col-md-6 d-flex mt-3'>  
                     <button onClick={buyHandle} className="product-select-button product-select-buy-button">اشترى الأن</button>
                     </div>
                    
                    </>
               
                   )}
                  
  
                  </div>               
  
                )}  
                {sizeSelect&&(
                <div className=' row p-2'>
                <div className='mb-3 d-flex align-items-center justify-content-between'>
                  
                  <p className='m-0 '>السعر</p>                    
                 
                     <p className='m-0'>{currencyFormat(product.price*quantity)} <span>ج.م</span></p>
                 </div>
                 {product?.quantity&&(
                  <>
                    <div className=' mt-3 d-flex align-items-center justify-content-between '>  
                <p >الكمية</p>
                    <InputSpinner quantity={quantity}
                    decrementQuantity={decrementQuantity} 
                    increaseQuantity={()=>increaseQuantity()}/>
                   </div>
                   <div className=' col-md-6 d-flex mt-3'>  
                     <button onClick={()=>add_item_cart(product)} className="product-select-button product-select-cart-button">أضافة للسلة</button>
                   </div>
                   <div className=' col-md-6 d-flex mt-3'>  
                   <button onClick={buyHandle} className="product-select-button product-select-buy-button">اشترى الأن</button>
                   </div>
                  
                  </>
             
                 )}
                

                </div>               

                )}
         </div>
        </div>
        <div className='opinion'>
            <ProductShow products={products} links={null} titles={titlesOpinion}/>
        </div>
    </div>
  )
}

export default ProductSelect
